import { render, staticRenderFns } from "./performanceDetail.vue?vue&type=template&id=2278e07c&scoped=true&"
import script from "./performanceDetail.vue?vue&type=script&lang=js&"
export * from "./performanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./performanceDetail.vue?vue&type=style&index=0&id=2278e07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278e07c",
  null
  
)

export default component.exports